import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'
import useAirportTransferHighlights from '../hooks/useAirportTransferHighlights'
import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'
import Caption from 'LuxKit/Typography/Caption'
import Image from 'components/Common/Image'
import { useIntl } from 'react-intl'

const Eyebrow = styled(Caption)`
  text-transform: uppercase;
`

const Cards = styled.div`
  display: grid;
  gap: ${rem(40)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const CardImage = styled.div`
  position: relative;
  height: ${rem(140)};
  overflow: hidden;
  border-radius: ${props => props.theme.borderRadius.L};
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

interface Props {
  onSearch: () => void
}

function CarsAirportTransferHighlights(props: Props) {
  const { onSearch } = props
  const highlights = useAirportTransferHighlights()

  const intl = useIntl()

  return (
    <Sheet padding="28 0" tabletPadding="64 0">
      <LayoutContainer>
        <Group direction="vertical" gap={20} tabletGap={32} horizontalAlign="center">
          <Group direction="vertical" gap={4}>
            <Eyebrow variant="small" weight="bold" align="center">
              {intl.formatMessage({
                id: 'yado-IpHL4NHPry_-DxT',
                defaultMessage: 'How it works',
                description: 'Eyebrow label introducing the airport transfer booking steps section',
              })}
            </Eyebrow>
            <Heading variant="heading3" align="center">
              {intl.formatMessage({
                id: 'H9x-auA0I4KqNwbD3GMx',
                defaultMessage: 'Your transfer, made easy.',
                description: 'Heading introducing the airport transfer booking steps and benefits section',
              })}
            </Heading>
          </Group>
          <Cards>
            {highlights.map(highlight => (
              <Group direction="vertical" gap={20} key={highlight.id} horizontalAlign="center" tabletHorizontalAlign="start">
                <CardImage>
                  <Image id={highlight.imageId} height={140} fit="center" objectFit="cover" />
                </CardImage>
                <Heading variant="heading4" align="center" tabletAlign="start">
                  {highlight.title}
                </Heading>
                <BodyText variant="medium" align="center" tabletAlign="start">
                  {highlight.description}
                </BodyText>
              </Group>
            ))}
          </Cards>
          <TextButton
            kind="primary"
            size="large"
            shape="round"
            type="button"
            onClick={onSearch}
          >
            {intl.formatMessage({
              id: 'IwtIhWyTtZa7l8SD5L8H',
              defaultMessage: 'Search airport transfers',
              description: 'Call to action button that opens the airport transfer search experience',
            })}
          </TextButton>
        </Group>
      </LayoutContainer>
    </Sheet>
  )
}

export default CarsAirportTransferHighlights
